import { render, staticRenderFns } from "./TyopoytaMyynninKuvaaja.vue?vue&type=template&id=a18475c4&scoped=true&"
import script from "./TyopoytaMyynninKuvaaja.vue?vue&type=script&lang=js&"
export * from "./TyopoytaMyynninKuvaaja.vue?vue&type=script&lang=js&"
import style0 from "./TyopoytaMyynninKuvaaja.vue?vue&type=style&index=0&id=a18475c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18475c4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a18475c4')) {
      api.createRecord('a18475c4', component.options)
    } else {
      api.reload('a18475c4', component.options)
    }
    module.hot.accept("./TyopoytaMyynninKuvaaja.vue?vue&type=template&id=a18475c4&scoped=true&", function () {
      api.rerender('a18475c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TyopoytaMyynninKuvaaja.vue"
export default component.exports